export const getHelpState = state => state.help;
export const getHelpData = state => getHelpState(state).data;
export const getHelpLoading = state => getHelpState(state).loading;
